<div class="modal-header" *ngIf="pageMode=='DIRECT'">
  <h4 class="modal-title pull-left">
    {{selectedTemplate?.template_name}}
  </h4>
  <button type="button" (click)="close()" class="btn-close close pull-right">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="card">
    <div class="body" (keyup.enter)="onSubmit()">
        <div>
            <app-form-generator *ngIf="pageMode=='PAGE'" #templateForm (onChangeEvent)="onChange($event)" [formData]="templateFormData" />
            <div class="row clearfix" *ngIf="basicFormData.length">
                <app-form-generator #basicForm (onChangeEvent)="onChange($event)" [formData]="basicFormData"
                    [dynamicValidator]="dynamicValidator" />
            </div>
            <div class="title p-0" *ngIf="filterFormData.length"> Report Filter </div>
            <div class="row clearfix" *ngIf="filterFormData.length">
                <app-form-generator #filterForm (onChangeEvent)="onChange($event)" [formData]="filterFormData"
                    [dynamicValidator]="dynamicValidator" />
            </div>

            <div class="col-md-12 mb-2 text-center">
                <span class="error" *ngIf="!isValid">Please Make sure all are Valid</span>
            </div>
            <div class="col-md-12 text-center">
                <div class="btn-group btn-group-lg">
                    <button noDoubleClick [disabled]="loading || !isValid" type="button" (click)="onSubmit()"
                        class="btn btn-primary mr-1">
                        <i *ngIf="loading" class="pi pi-spin pi-spinner"></i>
                        {{ loading ? 'Exporting...' : 'Export'}}
                    </button>
                    <button [disabled]="loading" (click)="close()" type="button"
                        class="btn btn-danger mr-1">Cancel</button>
                </div>
            </div>
        </div>
        <!-- loader -->
    </div>
    <!--end body -->
</div>